<body class="ltr main-body leftmenu">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="IAMarksForm">
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="col-md-12 prpl">
                                        <div class="row">
                                            <div class="col-md-6 prpl">
                                                <div class=" d-flex align-items-center">
                                                    <img alt="Logo" src="../../assets/img/attendance.png"
                                                        class="mh-45px pb-2">
                                                    <p class="mb-1">
                                                        <span class="main-content-label"><b>User Access For IA Marks</b></span><br>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-md-1"></div>
                                        </div>
                                        <hr class="mt-2">
                                        <div class="row clearfix mt-2">
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Session</mat-label>
                                                        <mat-select #select232 placeholder="Session" class="colorblack"
                                                            formControlName="SessionId">
                                                            <mat-select-filter *ngIf="select232.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                [array]="sessionList"
                                                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of SessionFilterList"
                                                                [value]="item.SnNo" (click)="getCourse(item.SnNo)">
                                                                {{item.SnName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            College
                                                        </mat-label>
                                                        <mat-select #select23 formControlName="college"
                                                            [displayMember]="'CgName'">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="collegeList"
                                                                (filteredReturn)="filteredCollegeList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCollegeList"
                                                                [value]="item.CgCode" (click)="getCourse(item.CgCode)">
                                                                {{item.CgCode}} - {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Course
                                                        </mat-label>
                                                        <mat-select #select55 class="colorblack"
                                                            formControlName="course">
                                                            <mat-select-filter *ngIf="select55.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="CourseList"
                                                                (filteredReturn)="filteredListCourse =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListCourse"
                                                                [value]="item.CoCode"
                                                                (click)="getExamList(item.CoCode)">
                                                                {{item.CoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Exam
                                                        </mat-label>
                                                        <mat-select #select23 placeholder="CoCode"
                                                            formControlName="EmId">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="examList"
                                                                (filteredReturn)="filteredListExam =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListExam"
                                                                [value]="item.EmId" (click)="getSubject(item)">
                                                                {{item.EmCoCode}}-{{item.EmName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2" *ngIf="isBranch">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Branch
                                                        </mat-label>
                                                        <mat-select #select23 placeholder="CoCode"
                                                            formControlName="Branch">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="BranchList"
                                                                (filteredReturn)="filteredListBranch =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListBranch"
                                                                [value]="item.StrId" (click)="getStr(item)">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Subject
                                                        </mat-label>
                                                        <mat-select #select2390 placeholder="Select Subject"
                                                            class="colorblack" formControlName="EsParentId" multiple>
                                                            <mat-select-filter *ngIf="select2390.focused"
                                                                [placeholder]="'Filter'">
                                                            </mat-select-filter>
                                                            <mat-option (click)="selectAllSubjects()"
                                                                [value]="'selectAll'"
                                                                [checked]="isAllSubjectsSelected()">
                                                                Select All
                                                            </mat-option>
                                                            <mat-option *ngFor="let item of filteredsubjectList"
                                                                disabled [value]="item.EsId"
                                                                [checked]="selectedSubject.includes(item.EsId)">
                                                                {{item.EsCode}}-{{item.EsName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="table-responsive mt-4" *ngIf="Table">
                                            <div class="container">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th class="f600" width="8%">Sr.No</th>
                                                            <th class="f600">Head</th>
                                                            <th class="f600">Supervisor</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="HeadArray">
                                                        <tr *ngFor="let markData of headTableData; let i = index"
                                                            [formGroupName]="i">
                                                            <td><input readonly class="tab2 form-control input-sm"
                                                                    formControlName="SrNo"></td>
                                                            <td><input readonly class="tab2 form-control input-sm"
                                                                    formControlName="EhDefName"></td>
                                                            <td>
                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label>User Name</mat-label>
                                                                    <mat-select #select23 required
                                                                        (selectionChange)="onSupervisorChange($event, i, markData)"
                                                                        placeholder="LoginId" class="colorblack"
                                                                        formControlName="LoginId">
                                                                        <mat-select-filter *ngIf="select23.focused"
                                                                            [placeholder]="'Filter'"
                                                                            [displayMember]="'LoginFullName'"
                                                                            [array]="userList"
                                                                            (filteredReturn)="filteredUserList =$event">
                                                                        </mat-select-filter>
                                                                        <mat-option
                                                                            *ngFor="let item of filteredUserList"
                                                                            [value]="item.LoginId">{{item.LoginId}} -
                                                                            {{item.LoginFullName}}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                    <mat-error class="margin_tp"
                                                                        *ngIf="HeadArray.at(i).get('LoginId')?.touched && HeadArray.at(i).get('LoginId')?.hasError('required')">
                                                                        Mandatory
                                                                    </mat-error>
                                                                </mat-form-field>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>



                                    </div>
                                    <div class="col-sm-12">

                                        <button *ngIf="SaveBtn" type="button"
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                            (click)="Save()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="15vh" src="../../assets/img/save.gif"
                                                    style="margin-right: 7px;">
                                                Save
                                            </span>
                                        </button>
                                        <button *ngIf="UpdateBtn" type="button"
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                            (click)="update()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="15vh" src="../../assets/img/edit1.gif"
                                                    style="margin-right: 7px;">
                                                Update
                                            </span>
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>